
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doc/terms-of-use",
      function () {
        return require("private-next-pages/doc/terms-of-use.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doc/terms-of-use"])
      });
    }
  